import * as React from "react";
import type { SVGProps } from "react";
const SvgUsageChartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      stroke="#155DFC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M2 2v10.667A1.333 1.333 0 0 0 3.333 14H14M12 11.333V6M8.667 11.333v-8M5.333 11.333v-2"
    />
  </svg>
);
export default SvgUsageChartIcon;
